import { ComprovantePayload } from "@/utils/comprovante";
import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export type GetChequesFiltro = {
  status?: string[];
  dataInicio?: string;
  dataFim?: string;
  unidadeIds?: number[];
  busca?: string;
};

export const getCheques = async (filtro?: GetChequesFiltro) => {
  const params = new URLSearchParams();
  filtro?.status?.forEach((s) => params.append("status", s));
  if (filtro?.dataInicio) params.append("dataInicio", filtro.dataInicio);
  if (filtro?.dataFim) params.append("dataFim", filtro.dataFim);
  filtro?.unidadeIds?.forEach((u) => params.append("unidadeIds", String(u)));
  if (filtro?.busca) params.append("busca", filtro.busca);

  const query = params.toString();
  const url = query ? `${API_CONSTANT_MAP.cheque}?${query}` : API_CONSTANT_MAP.cheque;
  return requestApi.get(url);
};

export const getChequeById = async (id: number) => {
  return requestApi.get(`${API_CONSTANT_MAP.cheque}/${id}`);
};

export const recolherCheques = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.cheque}/recolher`, { ids });
};

export const depositarCheques = (ids: number[], dataDeposito: string) => {
  return requestApi.put(`${API_CONSTANT_MAP.cheque}/depositar`, { ids, dataDeposito });
};

export const compensarCheques = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.cheque}/compensar`, { ids });
};

export const devolverCheque = (id: number, motivo: string) => {
  return requestApi.put(`${API_CONSTANT_MAP.cheque}/devolver`, { ids: [id], motivo });
};

export const resgatarCheques = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.cheque}/resgatar`, { ids });
};

export const solicitarCheques = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.cheque}/solicitar`, { ids });
};

export const trocarPagamentoCheque = (payload: {
  id: number;
  pagamentoId: number;
  cv?: number;
  dataTransacao?: string;
  /** Comprovante do PIX/Transferência, opcional — pode ser anexado depois. */
  comprovante?: ComprovantePayload | null;
}) => {
  return requestApi.put(`${API_CONSTANT_MAP.cheque}/trocar`, payload);
};

export const postChequeContato = (payload: {
  alunoChequeId: number;
  dataContato: string;
  acordo: string;
  prazo?: string;
  nomeContato: string;
}) => {
  return requestApi.post(`${API_CONSTANT_MAP.cheque}/contato`, payload);
};
